import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(({ palette }) => ({
  link: {
    color: ({ color }: { color?: string }) => color || palette.primary.main
  }
}));

export default useStyles;
